import React, { PureComponent } from 'react';
import { Button } from '@lt/components';
import { i18n } from '@lt/localization';
import { truncString } from '../../../../../../utils/stringUtils';

import { formatDateToDayFull } from '../../../../../../utils/dateUtils';
import TestimonialsPropType from '../../proptypes/testimonials';

const baseCls = 'checkout-testimonials';
const CONTENT_CUT_LENGTH = 240;

class TestimonialMobile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
    };
    this.showMoreInfo = () => this.setState({ showMore: true });
  }

  render() {
    const {
      data: { client, content, created_at },
    } = this.props;

    if (!content) return null;

    const { showMore } = this.state;
    const extendedLength = content?.length > CONTENT_CUT_LENGTH;
    const showButton = !showMore && extendedLength;

    const shownContent =
      showButton && extendedLength
        ? truncString(content, CONTENT_CUT_LENGTH)
        : content;

    return (
      <div className={`${baseCls}__item`}>
        <div className={`${baseCls}__header`}>
          <div className={`${baseCls}__avatar`}>
            <img src={client.photo} alt={client.name} />
          </div>
          <div className={`${baseCls}__info`}>
            <h3 className={`${baseCls}__name`}>{`${client.name}`}</h3>
            {client.ordered}
          </div>
        </div>
        <div className={`${baseCls}__content`}>
          <p>{shownContent}</p>
          <div className={`${baseCls}__addon`}>
            {showButton && (
              <Button
                functional
                className={`${baseCls}__button functional-button lt-link`}
                onClick={this.showMoreInfo}
              >
                {i18n.t('checkout.testimonial.readMore')}
              </Button>
            )}
            <span>{formatDateToDayFull(created_at)}</span>
          </div>
        </div>
      </div>
    );
  }
}

TestimonialMobile.propTypes = {
  data: TestimonialsPropType.isRequired,
};

export default TestimonialMobile;
